export const supplier = 'Supplier';
export const businessContact = 'Business Contact';
export const primaryContact = 'Primary Contact';
export const contractAmount = 'Contract Amt.';
export const noAwardees = 'This contract has no awardees.';
